// import { DialogComponent } from '@theme/dialog';
// import { CartAddEvent } from '@theme/events';

// /**
//  * A custom element that manages a cart drawer.
//  *
//  * @extends {DialogComponent}
//  */
// class CartDrawerComponent extends DialogComponent {
//   connectedCallback() {
//     super.connectedCallback();
//     document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
//   }

//   #handleCartAdd = () => {
//     if (this.hasAttribute('auto-open')) {
//       this.showDialog();
//     }
//   };

//   open() {
//     this.showDialog();

//     /**
//      * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
//      */
//     customElements.whenDefined('shopify-payment-terms').then(() => {
//       const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
//       const cta = installmentsContent?.querySelector('#shopify-installments-cta');
//       cta?.addEventListener('click', this.closeDialog, { once: true });
//     });
//   }

//   close() {
//     this.closeDialog();
//   }
// }

// if (!customElements.get('cart-drawer-component')) {
//   customElements.define('cart-drawer-component', CartDrawerComponent);
// }


import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, CartUpdateEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener(CartUpdateEvent.eventName, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener(CartUpdateEvent.eventName, this.#handleCartUpdate);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  /**
   * Handles cart update events and closes drawer on desktop when cart becomes empty
   * @param {CartUpdateEvent} event - The cart update event
   */
  #handleCartUpdate = (event) => {
    const itemCount = event.detail?.data?.itemCount;
    const isDesktop = window.innerWidth >= 750;
    
    // Close drawer on desktop when cart becomes empty
    if (itemCount === 0 && isDesktop && this.refs.dialog?.open) {
      // Force a reflow to fix overflow rendering issue
      const dialog = this.refs.dialog;
      if (dialog) {
        void dialog.offsetHeight; // Trigger reflow
        
        // Temporarily fix overflow to show empty state
        const inner = dialog.querySelector('.cart-drawer__inner');
        if (inner) {
          inner.style.overflow = 'visible';
        }
      }
      
      // Add a small delay to let users see the "cart is empty" message
      setTimeout(() => {
        this.closeDialog();
      }, 1000); // 1 second delay - adjust as needed
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}